export default __webpack_public_path__ + "static/media/man_final.1e190423.png";